import { paginationSchema } from '~/components/Pagination/Pagination.schema';
import { orderingSchema } from '~/hooks/useSortableTable';
import { z } from 'zod';

export const querySchema = z
  .object({
    district_id: z
      .string()
      .default('')
      .transform(x => (x ? Number(x) : undefined)),
    state: z.enum(['ALL', 'ACTIVE']).default('ACTIVE'),
    search: z.string().default(''),
  })
  .merge(paginationSchema)
  .merge(orderingSchema);
